import { saveToStorage } from "../utilities";

function storePrintValues(result) {
    saveToStorage("pac", result);
}

export { storePrintValues };
